module.exports = __webpack_public_path__ + "static/village-logo-cc2a35419c789b618e5544ee445db6dd.jpeg";